webpackJsonp([110386388766557],{

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _standardWrapper = __webpack_require__(27);
	
	var _standardWrapper2 = _interopRequireDefault(_standardWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var links = Object.entries({
	    "Wikipedia Deutschland Benutzer": "https://de.wikipedia.org/wiki/Benutzer:Birkenstab",
	    "Sourcer Profile": "https://sourcerer.io/Birkenstab"
	}).map(function (entry) {
	    return { text: entry[0], url: entry[1] };
	});
	
	var Links = function Links() {
	    return _react2.default.createElement(
	        _standardWrapper2.default,
	        null,
	        _react2.default.createElement(_reactHelmet2.default, {
	            title: 'Links \u2013 Birkenstab',
	            meta: [{ name: 'keywords', content: 'links, link' }]
	        }),
	        _react2.default.createElement(
	            'h1',
	            null,
	            'Links'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            links.map(function (link) {
	                return _react2.default.createElement(
	                    'li',
	                    { key: link.url },
	                    _react2.default.createElement(
	                        'a',
	                        { href: link.url },
	                        link.text
	                    )
	                );
	            })
	        )
	    );
	};
	
	exports.default = Links;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-links-js-267b1a707928a3349a79.js